<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="cvv-logo" [src]="'assets/images/png/card-cvv.png'" [srcset]="'assets/images/png/card-cvv@2x.png 2x,assets/images/png/card-cvv@3x.png 3x'" alt="logo"/>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <span
        class="cvv-info-text">{{this.textService.keyValueMapping('cvvTooltipDescription', 'CVV, kartın arka yüzünde bulunan 3 haneli koddur.', sdkInitTexts)}}</span>
    </div>
  </div>
</div>

